import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

const MiddlePage = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const location = useLocation();

  const flowType =
    location.state?.feature ||
    localStorage.getItem("flow_type") ||
    "mcq";

  const gradeId = localStorage.getItem("selected_grade");

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  /* ✅ RESPONSIVE */
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () =>
      window.removeEventListener("resize", handleResize);
  }, []);

  /* ================= NAVBAR HIDE / TOP SHOW ONLY ================= */
  useEffect(() => {
    const navbar =
      document.querySelector(".navbar");

    const handleScroll = () => {
      const currentScroll =
        window.pageYOffset;

      if (!navbar) return;

      /* top ekedi show */
      if (currentScroll <= 10) {
        navbar.style.transform =
          "translateX(-50%) translateY(0)";
        navbar.style.opacity = "1";
      }

      /* scroll una gaman hide */
      else {
        navbar.style.transform =
          "translateX(-50%) translateY(-130%)";
        navbar.style.opacity = "0";
      }
    };

    if (navbar) {
      navbar.style.position = "fixed";
      navbar.style.top = "15px";
      navbar.style.left = "50%";
      navbar.style.width = "90%";
      navbar.style.maxWidth = "1100px";
      navbar.style.transform =
        "translateX(-50%)";
      navbar.style.zIndex = "9999";
      navbar.style.transition =
        "all 0.35s ease";
    }

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () => {
      window.removeEventListener(
        "scroll",
        handleScroll
      );

      if (navbar) {
        navbar.style.transform =
          "translateX(-50%) translateY(0)";
        navbar.style.opacity = "1";
      }
    };
  }, []);

  /* ================= FETCH ================= */
  useEffect(() => {

    const fetchOptions = async () => {
      try {

        const res = await axios.get(
          "https://edunet.kmechengineering.com/root-engine1/api/path-data"
        );

        const paths = Array.isArray(
          res.data.path_data
        )
          ? res.data.path_data
          : [];

        setOptions(paths);

      } catch (error) {
        console.error(
          "PATH LOAD ERROR:",
          error
        );
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();

  }, []);

  if (loading) {
    return (
      <div style={styles.loading}>
        Loading...
      </div>
    );
  }

  return (

    <div style={styles.page}>

      <h1
        style={{
          ...styles.heading,
          fontSize: isMobile
            ? "24px"
            : "34px",
          textAlign: "center",
        }}
      >
        How Would You Like to Proceed?
      </h1>

      <div
        style={{
          ...styles.cardContainer,
          gap: isMobile
            ? "20px"
            : "40px",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >

        {options.map((opt) => {

          const iconUrl =
            opt.icon_path?.startsWith("http")
              ? opt.icon_path
              : `https://edunet.kmechengineering.com${opt.icon_path}`;

          return (

            <div
              key={opt.path_id}
              style={{
                ...styles.card,
                width: isMobile
                  ? "260px"
                  : "260px",
                maxWidth: "260px",
                height: isMobile
                  ? "260px"
                  : "260px",
              }}
              onClick={() => {

                const safeFeature = flowType;

                  if (opt.route === "teacher") {

                    navigate(
                      `/${safeFeature}/subject/${id}?grade_id=${gradeId}`
                    );

                  }else {
                  navigate(
                    `/${safeFeature}/${opt.route}/${id}`
                  );
                }

              }}
              onMouseEnter={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform =
                    "translateY(-10px)";
                  e.currentTarget.style.boxShadow =
                    "0 30px 70px rgba(0,0,0,0.9)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform =
                    "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 20px 40px rgba(0,0,0,0.6)";
                }
              }}
            >

              {/* 🔥 ICON BADGE */}
              <div style={styles.iconBox}>
                <img
                  src={iconUrl}
                  alt="icon"
                  style={styles.iconImg}
                />
              </div>

              <h2 style={styles.title}>
                {opt.title}
              </h2>

              <p style={styles.description}>
                {opt.description}
              </p>

              <div style={styles.button}>
                Explore →
              </div>

            </div>

          );

        })}

      </div>

    </div>

  );

};

export default MiddlePage;


/* ================= STYLES ================= */

const styles = {

  page: {
    minHeight: "100vh",
    background:
      "linear-gradient(135deg,#4f46e5,#7c3aed)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px"
  },

  heading: {
    fontWeight: "700",
    marginBottom: "40px",
    color: "#fff",
  },

  cardContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },

  card: {
    background:
      "linear-gradient(135deg, #0f172a, #020617)",
    borderRadius: "20px",
    textAlign: "center",
    cursor: "pointer",
    padding: "25px",
    transition: "0.3s ease",
    color: "#fff",
    position: "relative",
    boxShadow:
      "0 20px 40px rgba(0,0,0,0.6)",
    border:
      "1px solid rgba(255,255,255,0.08)",

    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },

  iconBox: {
    width: "55px",
    height: "55px",
    borderRadius: "14px",
    background:
      "linear-gradient(135deg,#6366f1,#8b5cf6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "15px"
  },

  iconImg: {
    width: "30px",
    height: "30px"
  },

  title: {
    fontWeight: "700",
    fontSize: "20px",
    marginBottom: "5px"
  },

  description: {
    marginBottom: "15px",
    color: "#94a3b8",
    fontSize: "14px"
  },

  button: {
    color: "#60a5fa",
    fontWeight: "600",
    fontSize: "14px"
  },

  loading: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "20px",
    color: "#fff",
    background:
      "linear-gradient(135deg,#4f46e5,#7c3aed)"
  }

};
